import { toPx, remStyle } from '@max/leez-style-util';
const config = {
    enabled: true,
    designWidth: 750
};
export const _toPx = (px) => {
    return toPx(px, config);
};
export const _remStyle = (style) => {
    return remStyle(style, config);
};
